import React from 'react';
import { BrowserRouter, Routes, Route, Navigate, useParams } from 'react-router-dom';
import { AuthProvider } from './context/AuthContext';
import { DashboardProvider } from './context/DashboardContext';
import Layout from './components/Layout';
import ProtectedRoute from './components/ProtectedRoute';
import Login from './pages/Login/Login';
import Dashboard from './pages/Dashboard/Dashboard';
import Reportes from './pages/Reportes/Reportes';
import Configuraciones from './pages/Configuraciones/Configuraciones';
import Organizaciones from './pages/Organizaciones/Organizaciones';
import Perfil from './pages/Perfil/Perfil';
import UpdatePrompt from './components/UpdatePrompt/UpdatePrompt';
import './App.css';

function LegacyConfiguracionesRedirect() {
  const { seccion } = useParams();
  const safeSection = String(seccion || 'usuarios').trim().toLowerCase();
  if (safeSection === 'usuarios' || safeSection === 'roles') {
    return <Navigate to={`/seguridad/${safeSection}`} replace />;
  }
  return <Navigate to="/organizaciones/empresas" replace />;
}

function App() {
  return (
    <AuthProvider>
      <DashboardProvider>
        <BrowserRouter>
          <UpdatePrompt />
          <Routes>
            <Route path="/login" element={<Login />} />
            <Route
              path="/dashboard"
              element={
                <ProtectedRoute>
                  <Layout>
                    <Dashboard />
                  </Layout>
                </ProtectedRoute>
              }
            />
            <Route
              path="/mod-reportes/:tipo"
              element={
                <ProtectedRoute>
                  <Layout>
                    <Reportes />
                  </Layout>
                </ProtectedRoute>
              }
            />
            <Route
              path="/seguridad/:seccion"
              element={
                <ProtectedRoute>
                  <Layout>
                    <Configuraciones />
                  </Layout>
                </ProtectedRoute>
              }
            />
            <Route path="/configuraciones/:seccion" element={<LegacyConfiguracionesRedirect />} />
            <Route
              path="/organizaciones/:seccion"
              element={
                <ProtectedRoute>
                  <Layout>
                    <Organizaciones />
                  </Layout>
                </ProtectedRoute>
              }
            />
            <Route
              path="/perfil"
              element={
                <ProtectedRoute>
                  <Layout>
                    <Perfil />
                  </Layout>
                </ProtectedRoute>
              }
            />
            <Route path="/" element={<Navigate to="/dashboard" replace />} />
            <Route path="*" element={<Navigate to="/dashboard" replace />} />
          </Routes>
        </BrowserRouter>
      </DashboardProvider>
    </AuthProvider>
  );
}

export default App;
